import React from 'react'

import { vistasData } from '../../../data/vistas.data';

interface Props {
  isVistas: boolean 
}

interface State {
  selectedPiso: any,
  selectedPisoIndex: number,
  currentThumbHovered: number,
  currentThumbSelected: number,
  currentImageSelected: any
}

class VistasContainer extends React.Component<Props,State>{
  constructor(props: Props){
    super(props);
    this.state = {
      selectedPiso: {},
      selectedPisoIndex: 0,
      currentThumbHovered: -1,
      currentThumbSelected: 0,
      currentImageSelected: ""
    }
  }

  componentDidMount(): void {
    this.setState({
      selectedPiso: vistasData().pisos[0],
      currentImageSelected: vistasData().pisos[0].galleries[0].image
    })
  }

  render(): React.ReactNode {
      return(
        <div className={this.props.isVistas ? "vistas-piso-container fade-in":"vistas-piso-container fade-out"}>
          <div className={"vistas-pisos-container"}>
            {
              vistasData().pisos.map((piso: any, index: number) => 
                <div className='vistas-pisos-individual-container' onClick={() => {this.setState({selectedPisoIndex: index, selectedPiso: piso, currentImageSelected: piso.galleries[0].image, currentThumbSelected: 0})}}>
                  <div className='vistas-pisos-img-container' >
                    <img src={piso.thumb} alt="" style={{border: this.state.selectedPisoIndex === index ? "0.2vw solid": "none"}}/>
                  </div>
                  <div className='vistas-pisos-name'>{piso.name}</div>
                </div>
              )
            }
          </div>
          <div className='vistas-selected-container'>
            <div className='vistas-image-container'>
                {
                  this.state.currentImageSelected !== "" ?
                  <img src={this.state.currentImageSelected} alt=""/>:null
                }
              </div>
            <div className='vistas-selected-thumbs-container'>
              {this.state.selectedPiso && this.state.selectedPiso.galleries ?
                this.state.selectedPiso.galleries.map((thumb: any, index: number) => 
                  <div 
                  className='vistas-selected-individual-thumb' 
                  onMouseEnter={() => {this.setState({currentThumbHovered: index})}} 
                  onMouseLeave={() => {this.setState({currentThumbHovered: -1})}}
                  onClick={() => {
                    this.setState({
                      currentImageSelected: thumb.image,
                      currentThumbSelected: index
                    })
                  }}
                  >
                    <img src={thumb.image} alt=""></img>
                    <div className={this.state.currentThumbHovered === index || this.state.currentThumbSelected === index ? "vista-selected-hovered":"vista-selected-collapsed"}>
                      <div className='current-apto-text'>{thumb.name}</div>
                    </div>
                  </div>
                ):null
              }
            </div>
          </div>
        </div>
      )
  }
}

export default VistasContainer